/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//
import { apiService } from 'services/ServiceRegistry';
import ListExpandable from 'components/ListExpandable';
import ListRow from 'components/ListExpandable/ListRow';
import isEmptyObject from 'utils/isEmptyObject';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
export default class ContractUsersRoleList extends React.Component<*> {
  /*eslint-disable max-len*/

  @observable users: Object = {};

  loadUsersPerRole = async (contractId: string, role: string) => {
    if (!Object.prototype.hasOwnProperty.call(this.users, role)) {
      this.users = await apiService.getResource(`contracts/${contractId}/user-role/${role}`);
    }

    return this.users[role];
  };

  getUrl = function(user: Object, accountId: string, contractId: string) {
    return NavigationService.formulateReportViewUri('/assets', {
      page: 1,
      filters: [
        { key: 'user', values: [user.id] },
        { key: 'account', values: [accountId] },
        { key: 'contract_id', values: [contractId] },
      ],
    });
  };

  renderUserRole = (
    title: string,
    contractId: string,
    accountId: string,
    role: string,
    i: number
  ) => {
    const { t } = this.props;

    return (
      <ListExpandable
        key={i}
        title={title}
        onExpand={async () => await this.loadUsersPerRole(contractId, role)}
        render={(users: Array<Object>) => {
          if (!users) {
            return null;
          }

          return users.map((user: Object) => (
            <ListRow
              key={user.id}
              text={user.name}
              textRight={`${user.assets_count} ${t('general:asset', { count: user.assets_count })}`}
              button={true}
              link={true}
              url={this.getUrl(user, accountId, contractId)}
              buttonText={t('general:actions.view_asset', { count: user.assets_count })}
              buttonDisabled={user.assets_count < 1}
            />
          ));
        }}
      />
    );
  };

  reformatTitle(role: string): string {
    if (role.length && role.indexOf('_') > -1) {
      return role.split('_').join(' ');
    }

    return role;
  }

  render(): ?React.Element<*> {
    const { details, t } = this.props;

    if (isEmptyObject(details.users_count)) {
      return null;
    }

    let list: React.Element<*>;
    let title: string;
    let i: number = 0;

    for (const role: string of Object.keys(details.users_count)) {
      title = `${this.reformatTitle(role)} (${details.users_count[role]})`;
      list = (
        <React.Fragment>
          {list}
          {this.renderUserRole(title, this.props.contractId, this.props.accountId, role, i)}
        </React.Fragment>
      );
      i++;
    }

    return (
      <section>
        <h3>{t('general:users.assigned_to_contract_assets')}</h3>
        {list}
      </section>
    );
  }
}
